export default {"src":"/_next/static/media/bxs-gift.5926f187.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};